import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Backlinks\"}}\n\n{{outlet}}")